const zip = document.querySelector('#CartDrawer-Pincode');
const deliveryContainer = document.getElementById('delivery-container');
const arrowBtn = document.getElementById('contine_zip_code');
const loader = document.getElementById('contine_zip_code_loader');

// Show arrow on focus and change bg
zip.addEventListener('focus', () => {
  arrowBtn.style.display = 'inline-block';
  zip.style.backgroundColor = 'white';
  zip.style.color = 'black';
});

zip.addEventListener('blur', () => {
  zip.style.backgroundColor = '#7C3778';
  zip.style.color = 'white';
});

// Show/hide arrow depending on input length
zip.addEventListener('input', () => {
  const value = zip.value.trim();
  if (value.length > 0 && value.length < 11) {
    arrowBtn.style.display = 'inline-block';
    
  } else {
    arrowBtn.style.display = 'inline-block';
    deliveryContainer.innerHTML = '';
  }
});

// Support Enter/Tab to submit
zip.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' || e.key === 'Tab') {
    e.preventDefault();
    if (zip.value.trim().length > 0) {
      iszipcodedelivarable();
    }
  }
});

// Button click triggers delivery check
arrowBtn.addEventListener('click', (e) => {
  e.preventDefault();
  iszipcodedelivarable();
});

const iszipcodedelivarable = async () => {
  const arrowBtn_div = document.getElementById('contine_zip_code');
  const loader_div = document.getElementById('contine_zip_code_loader');
  arrowBtn_div.style.display = "none";
  loader_div.style.display = "block";
  const zipcode = document.getElementById('CartDrawer-Pincode').value;
  const deliveryContainer_div = document.getElementById('delivery-container');
  zipcode.disabled = true;

  const request = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ zipcode }),
  };

  try {
    const response = await fetch(
      `${SHOPIFY_APP_BASE_URL_FOR_DRAWER}/get-country-province-from-zip`,
      request
    );
    const result = await response.json();

    if (result?.status?.toLowerCase() === "ok") {
      const { state, country } = result.data;
      const rateRes = await fetch(
        `/cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipcode}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${state}`
      );
      const shippingData = await rateRes.json();

      // const cheapestRate = shippingData.shipping_rates
      //   .filter(rate => parseFloat(rate.price) > 0)
      //   .reduce((cheapest, current) =>
      //     parseFloat(current.price) < parseFloat(cheapest.price) ? current : cheapest
      //   );
      // const deliveryDetails = `
      //   <div class="delivery-details">
      //     <p><strong>Service:</strong> ${cheapestRate.name}
      //       ${
      //         cheapestRate.delivery_range
      //           ? ` <strong>Delivery Date:</strong> ${formatDate(cheapestRate.delivery_range)} `
      //           : ` <strong>Delivery Date:</strong> Not specified `
      //       }
      //     </p>
      //   </div>
      // `;

      // deliveryContainer_div.innerHTML = deliveryDetails;
      const validRates = shippingData.shipping_rates.filter(rate => parseFloat(rate.price) > 0);

      let deliveryDetails = '';

      if (validRates.length > 0) {
        const cheapestRate = validRates
        .filter(rate => rate.delivery_range && rate.delivery_range.length !== 0)
        .reduce((cheapest, current) =>
          parseFloat(current.price) < parseFloat(cheapest.price) ? current : cheapest
        );
        deliveryDetails = `
          <div class="delivery-details">
            <p><strong>Service:</strong> ${cheapestRate.name}
              ${
                cheapestRate.delivery_range
                  ? ` <strong>Delivery Date:</strong> ${formatDate(cheapestRate.delivery_range)} `
                  : ` <strong>Delivery Date:</strong> Not specified `
              }
            </p>
          </div>
        `;
      } else {
        deliveryDetails = `
          <div class="delivery-details">
            <p><strong>Service:</strong>"Free Shipping" <br>
            <strong>Delivery Date:</strong> ${formatDate('')}</p>
          </div>
        `;
      }
      deliveryContainer_div.innerHTML = deliveryDetails;
    } else {
      zipcode.value = "";
      deliveryContainer_div.innerHTML = '';
      console.warn("Zip lookup failed:", result.message || "Unknown error");
    }
  } catch (error) {
    zipcode.value = "";
    deliveryContainer_div.innerHTML = '';
    console.error('Network error: ', error);
  } finally {
    // Re-enable input and update UI
    zipcode.disabled = false;
    loader_div.style.display = "none";
    arrowBtn_div.style.display = "inline-block";
  }
};


function formatDate(dateStrings) {
  //let dateStrings = ["2025-02-07","2025-02-08"]
  //console.log(dateStrings)
  if (!dateStrings || dateStrings.length !== 2) return "Not specified";
  const startDate = new Date(dateStrings[0]);
  const endDate = new Date(dateStrings[1]);
  const options = { weekday: "short", month: "short", day: "numeric" };

  // Adjust for weekends (Saturday and Sunday not deliverable)
  if (startDate.getDay() === 6) {
    startDate.setDate(startDate.getDate() + 2); // Move to Monday
  } else if (startDate.getDay() === 0) {
    startDate.setDate(startDate.getDate() + 1); // Move to MondayService: UPS® Ground  Delivery Date: Thu, Feb 6
  }

  if (endDate.getDay() === 6) {
    endDate.setDate(endDate.getDate() + 2); // Move to Monday
  } else if (endDate.getDay() === 0) {
    endDate.setDate(endDate.getDate() + 1); // Move to Monday
  }

  if (startDate.toLocaleDateString("en-US", options) == endDate.toLocaleDateString("en-US", options)) {
    endDate.setDate(endDate.getDate() + 1);
  }

  if (startDate.toLocaleDateString("en-US", options) !== endDate.toLocaleDateString("en-US", options)) {
    return `${startDate.toLocaleDateString("en-US", options)} - ${endDate.toLocaleDateString("en-US", options)}`;
  } else {
    return `${startDate.toLocaleDateString("en-US", options)}`;
  }
}

document.addEventListener('click', (event) => {
  const isClickInsideInput = zip.contains(event.target);
  const isClickOnArrow = arrowBtn.contains(event.target);

  if (!isClickInsideInput && !isClickOnArrow) {
    zip.style.backgroundColor = ''; // Reset to default on outside click
    arrowBtn.style.display = 'inline-block';
  }
});